import { EmailDetailsService } from '@/services/pages/clients/communication/email-details';
import { CustomToastrAction } from '@/actions/components/custom-toastr';
import { REDIRECT } from '@/constants/common/urls';
import { EmailDetailsAction } from '@/actions/pages/clients/communication/email-detail';

export class EmailsDetailsOptionsActions
{
    constructor(router, setApiError, setShowCandidateEmail)
    {
        this.emailDetailsService = new EmailDetailsService();
        this.customToastrAction = new CustomToastrAction();
        this.router = router
        this.setApiError = setApiError;
        this.emailDetailsAction = new EmailDetailsAction(setApiError, setShowCandidateEmail, router);
    }

    performJobAction(ActionName, params)
    {
        switch(ActionName)
        {
            case 'reply_all':
                            this.reply_all(params);
                            break;
            case 'forward':
                            this.forward(params);
                            break;
            case 'delete':
                params.setConfirmationModal({ state: true, message: 'Are you sure you want to delete this email ?', confirm_btn_action: () => { this.delete(params) } });
                            // this.dismiss(params);
                            break;
            default: '';
        }  
    }

    async reply_all(args)
    {   
        args.setEmailData(args.data || args.data)
        args.setMessageId(args.data?.comm_detail?.message_id || args.data.message_id)
        args.setReferences(args.data?.comm_detail?.references || args.data.references)
        args.setReplyTo(args.data?.comm_detail?.in_reply_to || args.data?.in_reply_to)
        args.setEmailFrom(args.data?.comm_detail?.from || args.data?.from);
        args.setEmailTo(args.data?.comm_detail?.to || args.data?.to);
        args.setForward(false);
        args.setShowCandidateEmail(true);
        args.setFlagForRerender(Math.random() * 10000);
    }

    async forward(args)
    {
        args.setEmailData(args.data || args.data)
        args.setForward(true);
        args.setShowCandidateEmail(true);
        args.setFlagForRerender(Math.random() * 10000);
    }

    async delete(args)
    {
        let params = { id: args.data?.comm_detail?.id || args.data.id, comm_detail_id: args.data?.comm_detail?.id || args.data.id}
        let result = await this.emailDetailsService.deleteEmail(params)
        if(result.request.status==200)
        {
            this.customToastrAction.setNormalToastr('The email has been deleted successfully.', 'success');
            let params = this.router.query;
            let comms_id = args.parentId ? args.parentId : this.router.query.comm_detail_id;
            let list_result = await this.emailDetailsService.getEmailDetailData(params, comms_id);
            this.setApiError(list_result.request);

            if(list_result.request.status==200)
            {
                args.setConfirmationModal({ state: false, message: '', confirm_btn_action: ''});
                args.setFlagForRerender(Math.random() * 10000);
                args.setEmailListingData(list_result.data);
                if(args.parentId )
                {
                    let link = REDIRECT.client.communication.emails.replace('$comm_detail_id', args.parentId ) ;
                    params.email_type = 'sent';
                    delete params['comm_detail_id'];
                    this.router.push({pathname: link, query: params});
                }
            }
            else
            {   
                let link = REDIRECT.client.communication.index ;
                delete params['comm_detail_id']
                this.router.push({pathname: link, query: params});
            }
        }
        else
        {
            this.showError(args, result); 
        }
    }

    showError(args, result)
    {
        args.setConfirmationModal({ state: false, message: '', confirm_btn_action: ''});
        args.setFlagForRerender(Math.random() * 10000);
        this.customToastrAction.setNormalToastr(result.response.data.error, 'warning'); 
    }
}